import { useQuery } from '@tanstack/react-query';

import { getJournalEntry, listJournalEntries, type JournalFilters } from '../../lib/api/endpoints';

export const journalKeys = {
  all: ['journal'] as const,
  list: (filters: JournalFilters) => ['journal', 'list', filters] as const,
  detail: (id: string) => ['journal', 'detail', id] as const,
};

export function useJournalEntries(filters: JournalFilters) {
  return useQuery({
    queryKey: journalKeys.list(filters),
    queryFn: () => listJournalEntries(filters),
  });
}

export function useJournalEntry(id: string) {
  return useQuery({
    queryKey: journalKeys.detail(id),
    queryFn: () => getJournalEntry(id),
    enabled: id.length > 0,
  });
}
